(() => {
  const popup = document.querySelector('[data-mereldon-popup]');
  if (!popup || popup.dataset.initialized === 'true') return;
  popup.dataset.initialized = 'true';

  const overlay = popup.querySelector('[data-popup-overlay]');
  const panel = popup.querySelector('[data-popup-panel]');
  const teaser = popup.querySelector('[data-popup-teaser]');
  const closeButton = popup.querySelector('[data-popup-close]');
  const form = popup.querySelector('.mereldon-popup__form');
  const success = popup.querySelector('[data-popup-success]');
  const error = popup.querySelector('[data-popup-error]');
  const copyButton = popup.querySelector('[data-popup-copy]');
  const copyLabel = popup.querySelector('[data-popup-copy-label]');
  const copyStatus = popup.querySelector('[data-popup-copy-status]');
  const continueLink = popup.querySelector('[data-popup-continue]');
  if (!overlay || !panel || !teaser || !closeButton || !form) return;
  if (popup.dataset.welcome10Applied === 'true') {
    popup.remove();
    return;
  }
  document.addEventListener('mereldon:cart-updated', (event) => {
    if (event.detail?.welcome10Applied) popup.remove();
  });

  const pageType = popup.dataset.pageType;
  const qs = new URLSearchParams(window.location.search);
  const preview = qs.get('mereldon_popup') === 'preview'
    || qs.get('preview_theme_id') === '206537851214'
    || Boolean(window.Shopify?.designMode);
  const eligiblePage = pageType === 'index' || pageType === 'collection';
  if (!preview && !eligiblePage) return;

  const dismissedKey = 'mereldon_popup_dismissed_until_v2';
  const subscribedKey = 'mereldon_popup_subscribed_v2';
  const shownKey = 'mereldon_popup_seen_session_v2';
  const pendingKey = 'mereldon_popup_pending_v2';
  const expiry = 30 * 24 * 60 * 60 * 1000;
  const mediaQuery = window.matchMedia('(max-width: 749px)');
  const getStore = (store, key) => {
    try { return store.getItem(key); } catch (_) { return null; }
  };
  const setStore = (store, key, value) => {
    try { store.setItem(key, value); } catch (_) {}
  };
  const removeStore = (store, key) => {
    try { store.removeItem(key); } catch (_) {}
  };
  const canUseTeaser = () => true;
  const eventContext = () => ({
    source: 'mereldon_welcome_popup',
    page_type: pageType,
    page_path: window.location.pathname
  });
  const track = (name, detail = {}) => {
    if (preview) return;
    const payload = { ...eventContext(), ...detail };
    try {
      const result = window.Shopify?.analytics?.publish?.(name, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (_) {}
    try {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...payload });
    } catch (_) {}
    window.dispatchEvent(new CustomEvent('mereldon:popup', { detail: { event: name, ...payload } }));
  };

  const lastDismissed = Number(getStore(localStorage, dismissedKey) || 0);
  const suppressed = Boolean(getStore(localStorage, subscribedKey)) || lastDismissed > Date.now();
  let lastFocus = null;
  let impressionTracked = false;

  const setTeaserVisibility = () => {
    teaser.hidden = !canUseTeaser() || Boolean(getStore(localStorage, subscribedKey));
  };

  const open = (trigger) => {
    lastFocus = document.activeElement;
    teaser.hidden = true;
    overlay.hidden = false;
    document.documentElement.classList.add('mereldon-popup-open');
    setStore(sessionStorage, shownKey, '1');
    if (!impressionTracked) {
      impressionTracked = true;
      track('popup_impression', { trigger });
    }
    track('popup_open', { trigger });
    const destination = success || form.querySelector('input, button, a');
    destination?.focus({ preventScroll: true });
  };

  const close = () => {
    overlay.hidden = true;
    document.documentElement.classList.remove('mereldon-popup-open');
    setStore(localStorage, dismissedKey, String(Date.now() + expiry));
    setTeaserVisibility();
    track('popup_dismiss');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  };

  closeButton.addEventListener('click', close);
  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) close();
  });
  teaser.addEventListener('click', () => open('teaser'));
  document.addEventListener('keydown', (event) => {
    if (overlay.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]')]
      .filter((element) => !element.hidden && element.getClientRects().length);
    if (!focusable.length) {
      event.preventDefault();
      panel.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  let validationErrorTracked = false;
  form.addEventListener('invalid', () => {
    if (validationErrorTracked) return;
    validationErrorTracked = true;
    track('popup_submit_error', { reason: 'client_validation' });
    window.setTimeout(() => {
      validationErrorTracked = false;
    }, 0);
  }, true);

  form.addEventListener('submit', (event) => {
    if (!form.checkValidity()) return;
    if (form.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }
    form.dataset.submitting = 'true';
    setStore(sessionStorage, pendingKey, String(Date.now()));
    track('popup_submit_attempt');
  });

  const copyCode = async () => {
    const code = copyButton?.dataset.code || 'WELCOME10';
    let copied = false;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
        copied = true;
      }
    } catch (_) {}
    if (!copied) {
      try {
        const fallback = document.createElement('textarea');
        fallback.value = code;
        fallback.setAttribute('readonly', '');
        fallback.style.position = 'fixed';
        fallback.style.opacity = '0';
        document.body.appendChild(fallback);
        fallback.select();
        copied = document.execCommand('copy');
        fallback.remove();
      } catch (_) {}
    }
    if (copied) {
      if (copyLabel) copyLabel.textContent = 'COPIED!';
      if (copyStatus) copyStatus.textContent = 'WELCOME10 copied to your clipboard.';
      track('popup_coupon_copy');
      window.setTimeout(() => {
        if (copyLabel) copyLabel.textContent = 'COPY CODE';
      }, 1800);
    } else if (copyStatus) {
      copyStatus.textContent = 'Copy was not available. Select the code above to copy it.';
    }
  };

  copyButton?.addEventListener('click', copyCode);
  continueLink?.addEventListener('click', () => track('popup_continue_shopping'));

  const pendingTime = Number(getStore(sessionStorage, pendingKey) || 0);
  const fromSubmission = pendingTime && Date.now() - pendingTime < 15 * 60 * 1000;
  if (success) {
    removeStore(sessionStorage, pendingKey);
    setStore(localStorage, subscribedKey, '1');
    open('submission');
    track('popup_submit_success');
    return;
  }
  if (fromSubmission && error) {
    removeStore(sessionStorage, pendingKey);
    open('submission_error');
    track('popup_submit_error', { reason: 'server_validation' });
    return;
  }

  setTeaserVisibility();
  if (preview) {
    open('preview');
    return;
  }
  if (suppressed || getStore(sessionStorage, shownKey)) return;

  const delay = Math.max(5, Number(mediaQuery.matches ? popup.dataset.mobileDelay : popup.dataset.desktopDelay) || 8) * 1000;
  window.setTimeout(() => {
    if (document.visibilityState !== 'visible' || getStore(sessionStorage, shownKey)) return;
    open('automatic');
  }, delay);
})();